import React, { useEffect } from 'react'
import HomeTabs from '../components/sub-components/HomeTabs'
import ChatInput from '../components/sub-components/ChatInput'
import {v4 as uuidV4} from 'uuid'
import { useDispatch } from 'react-redux'
import { resetDropdownValue } from '../slice/storage'





const HomeScreen = () => {


  return (
    <div className="flex flex-col h-[calc(100vh-50px)]">
  
      <main className="flex-grow flex flex-col items-center p-4 overflow-y-auto justify-center">
        <header className="p-4">
        <h1 className="text-2xl font-bold text-center text-custom-gray">Hallo, {localStorage.getItem("name")}. Starten Sie Ihre Analyse</h1>
      </header>
        <HomeTabs />

      </main>

      <div className="mb-10">
        <ChatInput />
      </div>
    </div>
  )
}

export default HomeScreen